function Preloader() {
  return (
    <div class="loader">
      <p className="tic">x</p>
      <span className="tic">TIC</span>
      <span className="tac"> TAC</span>
      <span className="toe"> TOE</span>
      <p className="tac">o</p>
    </div>
  );
}

export default Preloader;
